import { render } from "./InventoryCategoryView.vue?vue&type=template&id=fc2e221c"
import script from "./InventoryCategoryView.vue?vue&type=script&lang=js"
export * from "./InventoryCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__